import { ReactComponent as FilterIcon } from '../../assets/ml_summary_filter.svg';
import CustomDropdown from '.';
import { BoxProps } from '@mui/material';

type SectorOption = string | { name: string; isAllowed?: boolean } | { label: string; value: string };

type SectorFilterProps = {
	sectorName: string;
	setSectorName: React.Dispatch<React.SetStateAction<string>>;
	sectorOptionsList: SectorOption[];
	handleChange?: (value: string) => void;
	boxProps?: any;
	hasNotProvided?: boolean;
};

const sectorFilter = {
	backgroundColor: '#003771',
	// position: 'fixed',
	right: '35px',
	minWidth: '170px !important',
	zIndex: 999,
	'& fieldset': {
		display: 'none',
	},
	'& .MuiSelect-icon': {
		top: '0px !important',
		transition: 'none !important',
		height: '40px',
		width: '40px',
		right: '0px',
		position: 'absolute',
	},
	'& .MuiSelect-iconOpen': {
		transform: 'none',
	},
}

const SectorFilter = ({ 
	sectorName,
	setSectorName,
	sectorOptionsList,
	handleChange, boxProps, hasNotProvided = false }: SectorFilterProps) => {
		const { sx, ...props } = boxProps || {};
	const handleSectorChange = (e: any) => {
		const value = e.target.value;
		setSectorName(value);
		handleChange?.(value);
	};

	const normalizedOptions = sectorOptionsList.map((option: any) => {
		if (typeof option === 'string') {
			return { label: option.toUpperCase(), value: option };
		}
		if ('name' in option) {
			return {
				label: option.name.toUpperCase(),
				value: option.name,
				isDisabled: option.isAllowed === false,
			};
		}
		return { label: option.label?.toUpperCase(), value: option.value };
	});

	const hasValue = (val: string) =>
		normalizedOptions.some(opt => opt.value === val);

	const options = [
		...(hasValue('all')
			? []
			: [{ label: 'ALL SECTORS', value: 'all' }]),
		...(hasNotProvided && !hasValue('Not Provided')
			? [{ label: 'NOT PROVIDED', value: 'Not Provided' }]
			: []),
		...normalizedOptions,
	];

	return (
		<CustomDropdown
		disabled={boxProps?.disabled}
		value={sectorName}
		handleChange={handleSectorChange}
		options={options}
		dropdownIcon = {FilterIcon}
		boxProps={{
			sx: { ...sectorFilter, ...sx },
		}} />
	);
};

export default SectorFilter;
